// extracted by mini-css-extract-plugin
export var searchHeader = "_30-0";
export var searchHeaderDark = "_30-1";